/* eslint-disable no-unused-vars */
import { useCallback, useRef, useState, useId } from 'react';
import * as S from './CustomAutocomplete.styled';
import { CustomInput } from 'components';
import { useFloating, flip, offset, autoUpdate, autoPlacement } from '@floating-ui/react-dom';

const CustomAutocomplete = ({ defaultValue, options, onChange, width, id, withLabel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const name_id = useId();
  const { refs, floatingStyles } = useFloating({
    middleware: [
      autoPlacement({ alignment: 'bottom-start', autoAlignment: false }),
      flip(),
      offset(5),
    ],
    whileElementsMounted: autoUpdate,
  });

  const handleClick = useCallback((item) => {
    onChange(item);
  }, []);
  const inputRef = useRef(null);

  return (
    <>
      {isOpen && <S.Slice onClick={() => setIsOpen(false)} />}
      <S.Container width={width} onClick={() => setIsOpen(!isOpen)}>
        <S.InputContainer onClick={() => setIsOpen(!isOpen)} ref={refs.setReference}>
          <S.InputHeader ref={inputRef}>
            <CustomInput
              name={name_id}
              withLabel={withLabel}
              isDropdown
              arrowIconIsActive={isOpen}
              value={defaultValue.label}
              id={id}
            />
          </S.InputHeader>
        </S.InputContainer>
        {isOpen && (
          <S.ComponentForScroll
            isOpen={isOpen}
            ref={refs.setFloating}
            style={{
              minWidth: inputRef.current.offsetWidth,
              ...floatingStyles,
            }}
          >
            <S.Ul>
              {options?.map((item) => {
                return (
                  <S.Li
                    onClick={() => handleClick(item)}
                    key={item.value}
                    isActive={item.value === defaultValue.value}
                  >
                    <S.RadioBtn isActive={item.value === defaultValue.value} />
                    {item.label}
                  </S.Li>
                );
              })}
            </S.Ul>
          </S.ComponentForScroll>
        )}
      </S.Container>
    </>
  );
};
export default CustomAutocomplete;
